import { render, staticRenderFns } from "./IconFlag.vue?vue&type=template&id=58a54fb4&scoped=true&functional=true&"
import script from "./IconFlag.vue?vue&type=script&lang=ts&"
export * from "./IconFlag.vue?vue&type=script&lang=ts&"
import style0 from "./IconFlag.vue?vue&type=style&index=0&id=58a54fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "58a54fb4",
  null
  
)

export default component.exports